module.exports = __webpack_public_path__ + "static/media/table_column_total_row_sample_demo.44153367.png";